export const ASSETS_API = process.env['NX_ASSETS_API'] as string;

export const ASSETS_CDN_URL = process.env['NX_ASSETS_CDN_URL'] as string;

export const CLOUDFLARE_IMAGE_PREFIX = process.env[
  'NX_CLOUDFLARE_IMAGE_PREFIX'
] as string;
